import { useTranslation } from "@/lib/i18n";
import { AdditionalReportWidgetData } from "@/types/additional-widget-data";
import { HTMLTextContainer } from "@/features/shared/widgets/components";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

const Report = ({ id, data }: { id: string; data: AdditionalReportWidgetData }) => {
  const { t } = useTranslation();
  useRefetchWidget(id);

  const content = data.data[0]?.data?.texts[0];
  if (!data || content === "") {
    return <span>{t("widgets.no_data")}</span>;
  }

  return <HTMLTextContainer content={content} />;
};

export default Report;
